import { z } from 'zod'

import { VenueMetricBatchStatus } from '../constants/venueMetricBatch'
import { dbEntitySchema } from './system'

export const venueMetricBatchSchema = dbEntitySchema.extend({
  venue: z.string(),
  date: z.date(),
  status: z.nativeEnum(VenueMetricBatchStatus).optional(),
})

export const venueMetricBatchCreateArgsSchema = z.object({
  venueId: z.string().min(1, 'venueId is required'),
  date: z.date(),
})

export const venueMetricBatchListArgsSchema = z.object({
  venueId: z.string().optional(),
  venueIds: z.array(z.string()).optional(),
  dateStart: z.date().optional(),
  dateEnd: z.date().optional(),
  status: z.nativeEnum(VenueMetricBatchStatus).optional(),
})

export const venueMetricBatchListResponseSchema = z.object({
  data: z.array(venueMetricBatchSchema),
  total: z.number().optional(),
})
